import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { CoinflipDepositModalComponent } from '@features/games/coinflip/modals/coinflip-deposit-modal/coinflip-deposit-modal.component';
import { CoinflipWonModalComponent } from '@features/games/coinflip/modals/coinflip-won-modal/coinflip-won-modal.component';
import { CoinflipSkinsModalComponent } from '@features/games/coinflip/modals/coinflip-skins-modal/coinflip-skins-modal.component';
import { ViewCoinflipModalComponent } from '@features/games/coinflip/view-coinflip-modal/view-coinflip-modal.component';

export function provideCoinflipModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'CoinflipDepositModal', component: CoinflipDepositModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'CoinflipWonModal', component: CoinflipWonModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'CoinflipSkinsModal', component: CoinflipSkinsModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'CoinflipModal', component: ViewCoinflipModalComponent }, multi: true },
  ];
}
